/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Sitesettings_Add_Line1Inputs */

const vi_sitesettings_add_line1 = /** @type {(inputs: Sitesettings_Add_Line1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thêm dòng (tối đa ${i?.max})`)
};

/**

* @param {Sitesettings_Add_Line1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_add_line1 = /** @type {((inputs: Sitesettings_Add_Line1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Add_Line1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_add_line1(inputs)
});
export { sitesettings_add_line1 as "siteSettings_add_line" }